const campaignGallerySlider = document.querySelector('.gallery-slider');

if (campaignGallerySlider) {
    function updateArrowPosition(swiper) {
        const img = swiper.el.querySelector('.swiper-slide:not(.swiper-slide-duplicate) img');
        if (img) {
            swiper.el.style.setProperty('--arrow-top', (img.offsetHeight / 2) + 'px');
        }
    }

    const swiper = new Swiper(campaignGallerySlider, {
        slidesPerView: 1.25,
        spaceBetween: 8,
        centeredSlides: true,
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 24,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 32,
            },
        },
        on: {
            init: function () {
                updateArrowPosition(this);
            },
            resize: function () {
                updateArrowPosition(this);
            },
        },
    });
}